// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftComponents/SoftBox";
import PropTypes from 'prop-types';
import { getUserAccessLevel } from 'utils/setup';
import StopmonitorMap from "components/Maps/StopmonitorMap";
import { useEffect, useState } from "react";
import { enableMap } from "utils/map";
import { setDeviceColour } from "utils/device";

import mapboxgl from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax
import { useSoftUIController } from "hooks/context";
import StopmonitorSidebar from "components/Sidenavs/StopmonitorSidebar";
mapboxgl.accessToken = 'pk.eyJ1IjoiaGFycnltb250YW5vIiwiYSI6ImNqZWY0bDcyaTFkcGYzM28ydHFpaDJxaWcifQ.Wf7aNVePBRWZ9fMy_I81qw';

function setDeviceFeatures(device, user_type) {
    return {
        type: "Feature",
        properties: {
            ...device,
            access: getUserAccessLevel(user_type, 'technician'),
            feature_colour: setDeviceColour(device, user_type)
        },
        geometry: {
            type: 'Point',
            coordinates: device.position
        }
    }
}

function StopmonitorMapView({ map, user, devices }) {

    const [controller, dispatch] = useSoftUIController();
    const { deviceLayout } = controller;

    const [selectedDevice, setSelectedDevice] = useState(null);

    const set_padding = 300;

    useEffect(() => {
        if (!map.current) return;
        var bounds = new mapboxgl.LngLatBounds();

        devices.forEach(function (device) {
            var feature = setDeviceFeatures(device, user.user.user_type);
            bounds.extend(feature.geometry.coordinates);
        });

        if (map.current) {
            var options = {
                linear: true,
                padding: deviceLayout == 'mobile' ? set_padding / 2 : set_padding,
                pitch: 50,
                bearing: 0
            };

            const handleIdle = () => {
                map.current.fitBounds(bounds, options);
                map.current.off('idle', handleIdle); // Stops snapping back after first run
            };

            map.current.on('idle', handleIdle);
            return () => {
                map.current.off('idle', handleIdle);
            };
        }
    }, []);

    return (
        <SoftBox sx={{ width: '100%', height: '100%' }}>
            <StopmonitorMap {...{ map, user, devices, selectedDevice, setSelectedDevice }} />
            {selectedDevice != null && (
                <StopmonitorSidebar device={selectedDevice} user={user} setSelectedDevice={setSelectedDevice} />
            )}
        </SoftBox>
    );
}

StopmonitorMapView.propTypes = {
    map: PropTypes.object,
    user: PropTypes.object,
    devices: PropTypes.array
}

export default StopmonitorMapView;